<template>
    <BjDialog :visible="dialogVisible" width="400px" @close="dialogVisible = false">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="top">
            <el-form-item :label="$t('InternalSalesOrderDetails.pickUpTime')" prop="pickUpTime">
                <BjDateTimerPicker v-model="form.pickUpTime" :picker-options="pickerOptions"/>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
        </span>
    </BjDialog>
  </template>
  <script>
  import { orderApi } from '@/api';
  export default {
    data() {
      return {
        dialogVisible: false,
        form: {
            pickUpTime: '',
        },
        rules: {
            pickUpTime: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        },
        selectedRows: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < new Date().getTime();
          },
        }
      };
    },
    methods: {
      confirm() {
        this.$refs.form.validate(valid => {
          if (valid) {
            // const innerOrderNoList = this.selectedRows.map(item => item.innerOrderNo);
            // if (this.selectedRows.some(item => item.hjOrderStatus != 2)) return this.$message.warning(`${innerOrderNoList.join(',')}` + this.$t('InternalOrder.unshipped'));
            // if (this.selectedRows.some(item => item.takingDeliveryWay != 1)) return this.$message.warning(`${innerOrderNoList.join(',')}` + this.$t('InternalOrder.UnableToTakeDelivery'));
            orderApi.updatePickUpTime({
              innerOrderNoList: this.selectedRows,
              pickUpTime: this.form.pickUpTime
            }).then((res) => {
              if (!res.failed) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                this.dialogVisible = false;
                setTimeout(() => {
                  this.form.pickUpTime = '';
                  this.$emit('reFresh');
                }, 1000);
              }
            });
          }
        });
      },
    },
  };
  </script>
